// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__R8D6C","footer":"Form_footer__19jxJ"};